import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';

import {
  AppAside,
  AppBreadcrumb,
  AppFooter,
  AppSidebar,
  AppSidebarFooter,
  AppSidebarForm,
  AppSidebarHeader,
  AppSidebarNav,
  AppHeader
} from '@coreui/react';

// sidebar nav config
import navigation from '../../_nav';
// routes config
import routes from '../../routes';
import DefaultAside from './DefaultAside';
import DefaultFooter from './DefaultFooter';
import DefaultHeader from './DefaultHeader';

import { Auth } from 'aws-amplify';
import AuthCheck from './AuthCheck';

import IdleTimer from 'react-idle-timer';

const settings = require(`../../settings/${process.env.REACT_APP_CUSTOMER || 'default'}.js`);

class DefaultLayout extends Component {
  constructor(props) {
    super(props);
    this.idleTimer = null;
    this.onAction = this._onAction.bind(this)
    this.onActive = this._onActive.bind(this)
    this.onIdle = this._onIdle.bind(this)
  }

  _onAction(e) {
    // console.log('user did something', e)
  }

  _onActive(e) {
    console.log('user is active', e)
    console.log('time remaining', this.idleTimer.getRemainingTime())
  }

  _onIdle(e) {
    console.log('user is idle', e)
    console.log('last active', this.idleTimer.getLastActiveTime())
    Auth.signOut();
    window.location.reload();
  }
  
  render() {
    const { authState, authData, onStateChange } = this.props;
    return (
      <div className="app">
        <IdleTimer
          ref={ref => { this.idleTimer = ref }}
          element={document}
          onActive={this.onActive}
          onIdle={this.onIdle}
          onAction={this.onAction}
          debounce={250}
          timeout={settings.appConfig.timeout} 
        />
        <AppHeader fixed>
          <DefaultHeader
              authState={authState}
              authData={authData}
              onStateChange={onStateChange}
          />
        </AppHeader>
        <div className="app-body">
          <AppSidebar fixed display="lg">
            <AppSidebarHeader />
            <AppSidebarForm />
            <AppSidebarNav navConfig={navigation} {...this.props} />
            <AppSidebarFooter />
            {/* <AppSidebarMinimizer /> */}
          </AppSidebar>
          <main className="main">
            <AppBreadcrumb appRoutes={routes} className="bg-light" />
            <Container fluid>
              <Switch>
                {routes.map((route, idx) => {
                    return route.component ? 
                    (
                      <Route 
                        key={idx} 
                        path={route.path} 
                        exact={route.exact} 
                        name={route.name}
                        component={AuthCheck(route.component)}
                      />
                    )
                    : 
                    (null);
                  },
                )}
                <Redirect from="/" to="/dashboard" />
              </Switch>
            </Container>
          </main>
          <AppAside fixed hidden>
            <DefaultAside />
          </AppAside>
        </div>
        <AppFooter className="bg-white">
          <DefaultFooter />
        </AppFooter>
      </div>
    );
  }
}

export default DefaultLayout;
